var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuHyprFlowsSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8018_7572)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8018_7572",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 11,
    height: 11
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 0H0V11H11V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8018_7572)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.6499 1.87054H4.1499V4.37054H6.6499V1.87054Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 7H0V9.5H2.5V7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 7H4V9.5H6.5V7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 7H8V9.5H10.5V7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3009 5.99479C10.379 6.06305 10.4125 6.17657 10.4038 6.34197L10.6137 6.35289C10.626 6.11902 10.5687 5.95026 10.4392 5.83684C10.1278 5.56411 9.4743 5.68688 8.4849 5.87234C7.6607 6.02703 6.64498 6.21385 5.4922 6.23695V4.28595H5.28217V6.23695C4.12929 6.21385 3.11378 6.02703 2.28961 5.87234C1.30045 5.68677 0.646719 5.56411 0.335239 5.83684C0.205649 5.95026 0.148519 6.11913 0.160809 6.35289L0.370629 6.34197C0.361919 6.17667 0.39552 6.06315 0.47355 5.99479C0.70816 5.78948 1.38888 5.91718 2.25086 6.0789C3.07965 6.23422 4.09957 6.42304 5.26358 6.44762V6.45245C5.30548 6.45245 5.34571 6.45035 5.38719 6.45003C5.42877 6.45045 5.469 6.45245 5.5109 6.45245V6.44762C6.67491 6.42315 7.69493 6.23433 8.5236 6.0789C9.3855 5.91718 10.0663 5.78948 10.3009 5.99479Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8018_7572"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuHyprFlowsSelected);
export default __webpack_public_path__ + "static/media/Menu-HyprFlows-selected.d1fcc24586a13f2d0cd48b9b638fb673.svg";
export { ForwardRef as ReactComponent };